import { MapPin, ShieldCheck, Clock } from "lucide-react";
import { DEFAULT_CONTENT } from "@/constants/siteDefaults";

export default function About({ content }) {
  const heading = content?.about_heading || DEFAULT_CONTENT.about_heading;
  const text = content?.about_text || DEFAULT_CONTENT.about_text;
  return (
    <section id="about" className="py-24 px-6 md:px-12 lg:px-24 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-4">About us</p>
          <h2 className="font-outfit text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-slate-800" data-testid="about-heading">
            {heading}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600" data-testid="about-text">
            {text}
          </p>
          <ul className="mt-8 space-y-5">
            <li className="flex items-start gap-3">
              <ShieldCheck size={20} className="text-sky-500 mt-0.5 shrink-0" />
              <span className="text-base text-slate-700">Quality materials and workmanship on every job, residential or commercial.</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={20} className="text-sky-500 mt-0.5 shrink-0" />
              <span className="text-base text-slate-700">Prompt response — we aim to reply to every enquiry the same business day.</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={20} className="text-sky-500 mt-0.5 shrink-0" />
              <span className="text-base text-slate-700">Based at Unit 19B / 4 Louise Avenue, Ingleburn — locals serving locals.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
